import {
	IonContent,
	IonIcon,
	IonItem,
	IonLabel,
	IonList,
	IonListHeader,
	IonMenu,
	IonMenuToggle,
	IonNote,
	IonToggle,
	useIonAlert
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";
import {
	homeOutline,
	personOutline,
	trendingUp,
	cubeOutline,
	languageOutline,
	walletOutline,
	logOutOutline,
	peopleOutline
} from "ionicons/icons";
import "./Menu.css";
import { useEffect } from "react";
import Session from "../store/session";
import useStore from "../store/store";

interface AppPage {
	url: string;
	iosIcon: string;
	mdIcon: string;
	title: string;
}

const Menu = (props: any) => {
	const location = useLocation();
	const [presentAlert] = useIonAlert();
	const { language, setLanguage } = useStore(state => state);
	const { t, i18n } = useTranslation();
	const history = useHistory();

	useEffect(() => {
		i18n.changeLanguage(language === "tj" ? "tj" : "en");
	}, [language]);

	const handleLanguageChange = (e: any) =>
		setLanguage(e.target.checked ? "tj" : "en");

	const handleLogout = (e: any) => {
		e.preventDefault();
		presentAlert({
			header: `${t("logout")}`,
			buttons: [
				{
					text: `${t("cancel")}`,
					role: "cancel"
				},
				{
					text: `${t("yes")}`,
					role: "confirm",
					handler: () => {
						Session.logout();
						window.location.href = "/";
					}
				}
			]
		});
	};

	const appPages: AppPage[] = [
		{
			title: t("dashboard"),
			url: "/",
			iosIcon: cubeOutline,
			mdIcon: cubeOutline
		},
		{
			title: t("properties"),
			url: "/properties",
			iosIcon: homeOutline,
			mdIcon: homeOutline
		},
		{
			title: t("tenants"),
			url: "/tenants",
			iosIcon: personOutline,
			mdIcon: personOutline
		},
		{
			title: t("expanses"),
			url: "/expanses",
			iosIcon: trendingUp,
			mdIcon: trendingUp
		},
		{
			title: t("rents"),
			url: "/rents",
			iosIcon: walletOutline,
			mdIcon: walletOutline
		},
		{
			title: t("users"),
			url: "/users",
			iosIcon: peopleOutline,
			mdIcon: peopleOutline
		},
		{
			title: t("profile"),
			url: "/profile",
			iosIcon: personOutline,
			mdIcon: personOutline
		}
	];

	return (
		<IonMenu contentId="main" type="overlay">
			<IonContent>
				<IonList
					id="inbox-list"
					lines="none"
					style={{ borderBottom: 0 }}
				>
					<IonListHeader>
						<img
							style={{ width: "220px", cursor: "pointer" }}
							className="logo"
							onClick={() => history.push("/")}
						/>
					</IonListHeader>
					<IonNote style={{ marginTop: 10 }}>{t("slogan")}</IonNote>
					{appPages.map((appPage, index) => {
						return (
							<IonMenuToggle key={index} autoHide={false}>
								<IonItem
									className={
										location.pathname === appPage.url
											? "selected"
											: ""
									}
									routerLink={appPage.url}
									routerDirection="none"
									lines="none"
									detail={false}
								>
									<IonIcon
										slot="start"
										ios={appPage.iosIcon}
										md={appPage.mdIcon}
									/>
									<IonLabel>{appPage.title}</IonLabel>
								</IonItem>
							</IonMenuToggle>
						);
					})}

					<IonItem>
						<IonIcon slot="start" icon={languageOutline} />
						<IonLabel>
							{language === "tj" ? "Tоҷикӣ" : "Tоҷикӣ"}
						</IonLabel>
						<IonToggle
							slot="end"
							checked={language === "tj"}
							onIonChange={(e: any) => handleLanguageChange(e)}
						></IonToggle>
					</IonItem>
					<IonItem>
						<IonIcon
							slot="start"
							icon={logOutOutline}
							color="danger"
						/>
						<IonLabel onClick={handleLogout}>
							{t("logout")}
						</IonLabel>
					</IonItem>
				</IonList>
			</IonContent>
		</IonMenu>
	);
};

export default Menu;
